import script from "./PUR01_034INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR01_034INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR01_034INS.vue?vue&type=style&index=0&id=56ab1246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ab1246"]])

export default __exports__